import React, { useContext, useEffect } from 'react';
import Item from '../SliderImage/Item';
import useOnChange from '../../../../hooks/useChange';
import { ContextBuilder } from "../../../../context/builder/reducers";
import { SortableContainer } from "react-sortable-hoc";
import arrayMove from 'array-move';
import Input from '../Input';
import TextArea from '../TextArea';

const SortableList = SortableContainer(props => {
    return (
        <div className="slider-image">
            <h2>Slider image</h2>
            <div className="row">
                {props.elements.map((element, index) => {
                    return (<Item
                        key={`element-${index}`}
                        type={props.type}
                        itemIndex={index}
                        sortIndex={index}
                        index={index}
                        element={element}
                        onChange={props.onElementChange}
                        onSortEnd={props.onSortEnd}
                        addItem={props.addItem}
                        deleteButtonHandler={props.deleteButtonHandler}
                    />);
                })}
            </div>

            <div className="add-element">
                <div className="button" onClick={props.addItem}>
                    +
                </div>
            </div>
        </div>
    );
});
const defaultData = {
    textBlock1: { title: '', description: '' },
    textBlock2: { title: '', description: '' },
    elements: []
}
export default props => {
    const { state, dispatch } = useContext(ContextBuilder);
    const onChange = useOnChange(props.index);

    useEffect(() => {
        if (!props.content) {
            const data = state.data;
            data.value[props.index].content = {
                ...defaultData
            }
            dispatch({ type: 'data', payload: { data } })
        }
    });
    let content = props.content || { ...defaultData };
    let elements = props.content.elements || [];

    const addItem = () => {
        const data = state.data;
        elements = [...elements, { text: '', img: '', title: '' }];
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const onSortEnd = ({ oldIndex, newIndex }) => {
        const data = state.data;
        elements = arrayMove(elements, oldIndex, newIndex);
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    const deleteButtonHandler = (e) => {
        const index = e.currentTarget.getAttribute('index');
        const data = state.data;
        elements.splice(index, 1);
        data.value[props.index].content.elements = elements;
        dispatch({ type: 'data', payload: { data: data } });
    };

    return (
        <div className="slide-image-about-us">
            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <label>Title</label>
                        <Input name="textBlock1.title" onChange={onChange} value={content.textBlock1.title}/>
                    </div>
                    <div className="form-group">
                        <label>Description</label>
                        <TextArea name="textBlock1.description" onChange={onChange} value={content.textBlock1.description}/>
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group">
                        <label>Title</label>
                        <Input onChange={onChange} name="textBlock2.title" value={content.textBlock2.title}/>
                    </div>
                    <div className="form-group">
                        <label>Description</label>
                        <TextArea name="textBlock2.description" value={content.textBlock2.description} onChange={onChange}/>
                    </div>
                </div>
            </div>
            <SortableList
                type={props.type}
                elements={elements}
                onElementChange={onChange}
                onSortEnd={onSortEnd}
                addItem={addItem}
                deleteButtonHandler={deleteButtonHandler}
                axis="xy"
                useDragHandle
            />
        </div>
    );
}
